import { EnvelopeFill, Facebook, TwitterX } from "react-bootstrap-icons";
import logo from "../assets/iRise-psychology-Logo2.png";
import doctify from "../assets/Doctify.png";
// import BPS from "../assets/BPS.png";
// import HCPC from "../assets/hcpc.png";

import hcpc from "../assets/hcpc-bps.png";

const Emails = [
  {
    name: "Dr Benjamin Piper",
    email: "benjamin.piper@irise-psychology.london",
  },
  {
    name: "Dr René De Barr",
    email: "rene.debarr@irise-psychology.london",
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="py-5 bg-black text-white-50">
      <div className="main-wrap">
        <div className="row g-4 align-items-center">
          <div className="col-12 col-md-6">
            <img
              src={logo}
              alt="iRise Psychology"
              className="hero-logo-image mb-2"
            />
            <div className="small">
              Registered in England, company number 09132912
            </div>
          </div>

          <div className="col-12 col-md-6 d-flex justify-content-md-end">
            <div className="d-flex gap-2 align-items-center">
              {/* <a
                className="footer-icon"
                href="https://x.com/irisepsychology"
                target="_blank"
                rel="noreferrer"
                aria-label="X"
              >
                <TwitterX size={18} />
              </a>

              <a
                className="footer-icon"
                href="https://www.facebook.com/IRisepsychology/"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a> */}

              <div className="dropdown">
                <button
                  className="footer-icon"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  aria-label="Email"
                >
                  <EnvelopeFill size={18} />
                </button>

                <ul className="dropdown-menu dropdown-menu-end">
                  {Emails.map((e) => (
                    <li key={e.email}>
                      <a className="dropdown-item" href={`mailto:${e.email}`}>
                        {e.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <hr className="border-secondary my-4 footer-divider" />

        <div className="d-flex flex-column flex-md-row align-items-center gap-3 mb-4">
          <div className="d-flex align-items-center gap-3">
            <a
              href="https://www.doctify.com/uk/specialist/dr-benjamin-piper"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={doctify}
                alt="British Psychological Society and HCPC Registered"
                className="footer-accreditation"
              />
            </a>
          </div>
          <div className=" ">
            <p className="small text-white-50 my-0 mx-3">Registered with</p>
            <img
              src={hcpc}
              alt="British Psychological Society and HCPC Registered"
              className="footer-accreditation"
            />
          </div>
        </div>

        <div className="d-flex flex-column flex-md-row  align-items-center gap-3 small">
          <div>© {year} iRise Psychology</div>
        </div>

        <div className="footer-legal">
          <a
            className="footer-link"
            href="/irise-contract.pdf"
            target="_blank"
            rel="noreferrer"
          >
            iRise Contract
          </a>{" "}
          |{" "}
          <a href="/download" className="footer-link">
            {" "}
            Mobile App
          </a>
        </div>
      </div>
    </footer>
  );
}
